import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  REPORTS,
  REPORTS_LOADER,
  SELECTED_REPORT,
  RESPONSE_STATE,
  VALUE,
  CAMPAIGN_NAMES,
} = STATE_IDENTIFIER;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [REPORTS]: [],
  [REPORTS_LOADER]: false,
  [SELECTED_REPORT]: {},
  [RESPONSE_STATE]: IResponseState.PENDING,
  [VALUE]: [],
  [CAMPAIGN_NAMES]: [],
};
